const endpoints = {
  "TEMPLATES_LAMBDA_BASE": process.env.TEMPLATES_LAMBDA_BASE_URL || "http://localhost:4004/marley-templates",
  "WEB_APP": process.env.APP_HOST || "http://localhost:3000",
  "MOBILE_APP_API": process.env.MOBILE_API_BASE_URL || "http://localhost:4000",
  "EC_OKTA_CLIENT_ID": process.env.EC_OKTA_CLIENT_ID || "0oasg72s1aXjLkIIP0h7",
  "OKTA_BASE_URL": process.env.OKTA_BASE_URL || "https://himarley-prod.oktapreview.com",
  "OKTA_ISSUER": process.env.OKTA_ISSUER || `https://himarley-prod.oktapreview.com/oauth2/ausqt450vmoOdOEbT0h7`,
}

export default endpoints